<template>
    <div class="card" v-show="ready">

        <div class="card-header border-0">
            <div class="row">
                <div class="col-12">
                    <h3 class="mb-0 text-uppercase">{{ $t('common.testers') }}</h3>
                </div>
            </div>
        </div>

        <p class="card-body pt-0 text-sm" v-if="empty">{{ $t('cohorts.no-member') }}</p>

        <div v-if="!empty">
            
            <table-control :search="true" v-model="search"></table-control>

            <el-table class="table-responsive table-flush"
                    :show-header="false"
                    :empty-text="$t('cohorts.no-member-found')"
                    :data="filteredData">

                <el-table-column width="72">
                    <template v-slot="{row}">
                        <span class="avatar rounded-circle">
                            <img :src="row.avatar">
                        </span>
                    </template>
                </el-table-column>

                <el-table-column>
                    <template v-slot="{row}">
                        <h4 class="mb-0">
                            {{ row.name }}
                        </h4>
                        <small v-if="row.owner">
                            {{ row.owner.name }}
                        </small>
                        <small v-if="row.entity">
                            / {{ row.entity.name }}
                        </small>
                    </template>
                </el-table-column>

                <el-table-column align="right" class-name="actions" v-if="canSimplyRemoveMember">
                    <template v-slot="{row}">

                        <a href="#" class="table-action text-danger" v-if="canActOnMember(row)"
                                @click.prevent="removeMember(row.id)">
                            <i class="tim-icons icon-simple-remove"></i>
                        </a>

                    </template>
                </el-table-column>
                
            </el-table>

            <table-pagination :paging="paging"></table-pagination>
        </div>
    </div>
</template>

<script>
    export default {

        props: {

            registration: {
                type: Object,
                required: true
            },

            ready: {
                type: Boolean,
                required: false
            },
        },

        data() {
            return {
                paging: {
                    currentPage: 1,
                    perPage: 10,
                    total: 0
                },
                search: '',
            }
        },

        computed: {

            canSimplyRemoveMember() {
                return this.registration.status != 'archived'
            },

            empty() {
                return !this.registration.testers || (this.registration.testers.length == 0 && !this.search)
            },

            filteredData() {
                // Search filter.
                let testers = this.registration.testers.filter(member => !this.search
                    || member.name.toLowerCase().includes(this.search.toLowerCase())
                )
                // Sorting.
                testers = testers.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1)
                this.paging.total = testers.length
                return testers.slice((this.paging.currentPage - 1) * this.paging.perPage, this.paging.currentPage * this.paging.perPage)
            },
        },

        methods: {

            canActOnMember(row) {
                return !this.$auth.user.owner_id || this.$auth.user.owner_id == row.owner_id
            },

            removeMember(id) {
                axios.delete('/socrates/api/front/registrations/'+this.$route.params.id+'/members/'+id)
                .then(resp => {
                    this.$emit('change');
                })
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            },
        }
    }
</script>

<style scoped>

    .disabled, .disabled h4 {
        color: #bbb !important;
    }
    .disabled img {
        opacity: 0.5;
    }
    .card >>> th,
    .card >>> td {
        padding-right: 0;
    }
    .card >>> th.actions,
    .card >>> td.actions {
        padding-right: 1.5rem;
    }
    .card >>> .table-control form {
        width: 100%;
    }

</style>
